"use client";

import { getDictionary } from "@/i18n/get-dictionary";
import { Locale } from "@/i18n/i18n.config";
import { createContext, useContext } from "react";

export type Translations = Awaited<ReturnType<typeof getDictionary>>;
export type BuilderComponentTranslations = Translations["builder"];
export type StoriesTranslations = BuilderComponentTranslations["stories"];

interface LocaleContextType {
  locale: Locale;
  translations: Translations;
}

const LocaleContext = createContext<LocaleContextType>(null!);

export default function LocaleProvider({
  children,
  locale,
  translations,
}: { children: React.ReactNode } & LocaleContextType) {
  return <LocaleContext.Provider value={{ locale, translations }}>{children}</LocaleContext.Provider>;
}

export function useLocale() {
  return useContext(LocaleContext).locale;
}

export function useTranslations() {
  return useContext(LocaleContext).translations;
}
